import React from 'react';

import cn from 'classnames';

import { FinanceExportTable } from '@widgets/FinanceExportTable';

import cls from './FinanceExport.module.css';

interface FinanceExportProps {
    classes?: string;
}

export const FinanceExport = ({ classes }: FinanceExportProps) => (
    <div className={cn(cls.FinanceExport, classes)}>
        {/* <FinanceExportHeader /> */}
        <FinanceExportTable />
    </div>
);
